import { useQuery } from 'react-query';

import { QueryEntity } from '../../types';
import { User } from '../../types/backend-dto-types';
import useGetFetchConfig from '../../useGetFetchConfig';
import { APIBaseChronos } from '@/api/hosts';

const useFetchOrgUsers = (orgIds: string[] = []) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<User[]>(
    [QueryEntity.Users, orgIds],
    async () => {
      const params = new URLSearchParams({
        orgIds: orgIds.join(','),
      });
      const queryParams = params.toString();

      try {
        const res = await fetch(`${APIBaseChronos}/api/org/users?${queryParams}`, fetchConfigGET);
        return await res.json();
      } catch (err) {
        throw err;
      }
    },
    {
      refetchOnWindowFocus: false,
    },
  );
};

export default useFetchOrgUsers;
